import React from 'react';
import { Box } from '@nerdwallet/currency';
import StructuredContent from '@nerdwallet/structured-content';

export const MarketplaceRateTable = (): JSX.Element => {
  const document = {
    type: 'Document',
    version: '1.0.0',
    props: {
      children: [
        {
          type: 'Container',
          version: '1.0.0',
          props: {
            spacing: {
              bottom: 0,
            },
            children: [
              {
                type: 'MarketplaceRateTable',
                version: '1.0.0',
                props: {
                  productType: 'mortgages',
                  subCategory: 'mortgage_marketplace_named_queries',
                  showAdvertiserWrapper: true,
                },
              },
            ],
          },
        },
      ],
    },
  };

  return (
    <Box>
      <StructuredContent>{document}</StructuredContent>
    </Box>
  );
};
